<li class="main-nav-item" [class.collapsed]="useOverlay()">
  @if (navItem().children.length) {
    <!-- floating menu -->
    @if (isFloatingMenuActive()) {
      <cov-floating-menu [navItems]="navItem().children" />
    }
    <mat-expansion-panel
      [expanded]="itemGroupExpanded() && !useOverlay()"
      (click)="activateNavItem($event)"
      (mouseenter)="!isActiveFloatingMenuItem() && activateNavItem($event)"
      (opened)="navItemContainerOpened.emit(navItem())"
    >
      <mat-expansion-panel-header [class.active-floating-menu]="isFloatingMenuActive()">
        <div class="main-nav-item-link">
          <ng-container *ngTemplateOutlet="label"></ng-container>
        </div>
      </mat-expansion-panel-header>
      <ul class="child-nav-list">
        @for (childItem of navItem().children; track childItem.route) {
          <cov-sub-navigation-item [navItem]="childItem">
            {{ childItem.label }}
          </cov-sub-navigation-item>
        }
      </ul>
    </mat-expansion-panel>
  } @else {
    @if (navItem().isExternal) {
      <a class="main-nav-item-link" [href]="navItem().route" (click)="activateNavItem($event)">
        <ng-container *ngTemplateOutlet="label"></ng-container>
      </a>
    } @else {
      <a
        class="main-nav-item-link"
        [routerLink]="navItem().route"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{exact:true}"
        (click)="activateNavItem($event)"
      >
        <ng-container *ngTemplateOutlet="label"></ng-container>
      </a>
    }
  }
</li>

<ng-template #label>
  @if (navItem().icon) {
    <cov-icon class="nav-item-icon" [iconName]="navItem().icon!" />
  }
  <span class="nav-item-label">
    <ng-content></ng-content>
  </span>
</ng-template>
